import React, { useCallback } from "react";
import { Pressable, StyleSheet } from "react-native";
import { Fontisto } from "@expo/vector-icons";
import { router } from "expo-router";
import { Image } from "expo-image";

import UserNotificationBaseItem from "./UserNotificationBaseItem";

import type {
  UserNotification,
  UserNotificationImageLikeData,
} from "@/schemas/user/notification";
import type { UserLikableImageMedia } from "@/schemas/user/image";

type Props = {
  userNotification: UserNotification;
  handleMarkNotificationAsRead: () => void;
};

function UserNotificationImageLikeItem({
  userNotification,
  handleMarkNotificationAsRead,
}: Props): React.JSX.Element {
  const notificationData =
    userNotification.data as UserNotificationImageLikeData;
  const profilePreview = notificationData.imageLike.likedBy;
  const likedImage = notificationData.imageLike.likedImage;

  const handleImagePreviewPress = async (
    imageMedia: UserLikableImageMedia,
  ): Promise<void> => {
    router.push({
      params: { imageMedia: JSON.stringify(imageMedia) },
      pathname: "/(main)/shared/image",
    });
  };

  const renderRightComponent = useCallback(
    (markAsRead: () => void): React.JSX.Element => {
      return (
        <Pressable
          onPress={() => {
            markAsRead();
            handleImagePreviewPress(likedImage);
          }}
        >
          <Image
            source={{ uri: likedImage.image.attributes.previewUrl }}
            style={styles.image}
            contentFit="cover"
            cachePolicy="memory-disk"
          />
        </Pressable>
      );
    },
    [likedImage],
  );

  return (
    <UserNotificationBaseItem
      renderRightComponent={renderRightComponent}
      userNotification={userNotification}
      profile={profilePreview}
      handleMarkNotificationAsRead={handleMarkNotificationAsRead}
      notificationTypeIconComponent={
        <Fontisto name="heart-alt" size={14} color="red" />
      }
      notificationDescription={"liked you photo"}
    />
  );
}

const styles = StyleSheet.create({
  image: {
    width: 60,
    height: 60,
    borderRadius: 8,
  },
});

export default UserNotificationImageLikeItem;
